import { Statement } from "../../types"
import { Icon } from "source/shared/components"
import { Heading } from "@planningcenter/doxy-web"
import pluralize from "source/shared/pluralize"
import { css } from "@emotion/react"
import { formattedCents } from "source/giving/utils/money"

type StatementDetailsProps = {
  statement: Statement
}

export function StatementDetails({ statement }: StatementDetailsProps) {
  const formatDate = (date: string): string => {
    return new Date(date).toLocaleDateString()
  }

  return (
    <div className="action-drawer d-f br-8p jc-sb g-1">
      <div className="w-100%">
        <div className="d-f fd-c fd-r@sm g-4p g-1@sm ai-fs jc-sb">
          <Heading
            level={2}
            size={4}
            isUppercase={true}
            text={statement.name}
            color="tint1"
          />
          <span className="fs-13 c-tint1 fw-600 ws-nw mt-1p">
            {formatDate(statement.starts_on)} - {formatDate(statement.ends_on)}
          </span>
        </div>
        <div>
          <span className="fs-13 c-tint2 fw-500">
            {pluralize(statement.donation_count, "Donation")}{" "}
            {formattedCents(statement.amount_cents, {
              noCentsIfWhole: false,
            })}
          </span>
        </div>
      </div>
      <a
        href={statement.download_url}
        aria-label="Download this statement"
        className="clickable-icon d-if br-4p c-tint2"
        tabIndex={0}
        css={css`
          padding: 5px 0px 4px 2px !important;
        `}
      >
        <Icon
          symbol="general#right-chevron"
          aria-hidden="true"
          css={css`
            height: 12px;
            width: 12px;
          `}
        />
      </a>
    </div>
  )
}
